
<template>
  <div id="Product" @contextmenu.prevent>
	
	<div style="position: relative; justify-content: center;">
	<img src='/image/1-1.png' style="width:100%">
	</div>
	<div style="position: relative; justify-content: center;">
	<img src='/image/1-2.png' style="width:100%">
	</div>
	<div style="position: relative; justify-content: center;">
	<img src='/image/1-3.png' style="width:100%">
	</div>
	<div style="position: relative; justify-content: center;">
	<img src='/image/1-4.png' style="width:100%">
	</div>
  </div>
</template>
 
<script>
export default {
  name: 'Product'
};
</script>